import React, { useEffect, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

// WPark Components
import WParkNavbar from "./components/WParkNavbar";
import WParkFooter from "./components/WParkFooter";
import Wpark from "./pages/Wpark";
import WParkWaitlist from "./components/WParkWaitlist";
import ScrollToTop from "./components/Scrolltotop.js";


// Favicon
import wparkFavicon from "./assets/WPARK_logo.png";
import Team from "./components/Team.js";
import ProductPanels from "./components/Product.js";
import Newsroom from "./components/Newsroom.js";
import MissionPage from "./pages/Mission.js";
import Fellows from "./components/Fellows.js";
import People from "./components/People.js";
import BrandBar from "./components/Brandbar.js";
import Advisors from "./components/Advisors.js";


// Lazy-loaded Dashboard (isolated — must come AFTER all imports)
const DashboardApp = lazy(() =>
  import("./Dashboard/DashboardApp.tsx")
);

const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = "WPark";

    const updateFavicon = (url) => {
      let link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = url;
      } else {
        link = document.createElement("link");
        link.rel = "icon";
        link.type = "image/png";
        link.href = url;
        document.head.appendChild(link);
      }
    };

    updateFavicon(wparkFavicon);
  }, []);

  const isDashboard = location.pathname.startsWith("/dashboard");

  return (
    <div className="app-root">
      {/* Show navbar only for main site */}
      <BrandBar />
      <ScrollToTop />
      <Routes>
        {/* WPark pages */}
        <Route path="/" element={<Wpark />} />
        <Route path="/team" element={<Team />} />
        <Route path="/product" element={<ProductPanels />} />
        <Route path="/newsroom" element={<Newsroom />} />
        <Route path="/mission" element={<MissionPage/>} />
        <Route path="/waitlist" element={<WParkWaitlist />} />
        <Route path="/fellows" element={<Fellows />} />
        <Route path="/people" element={<People />} />
         <Route path="/advisors" element={<Advisors />} />




        {/* Dashboard (fully isolated + lazy-loaded) */}
        <Route
          path="/dashboard/*"
          element={
            <Suspense fallback={null}>
              <DashboardApp />
            </Suspense>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Show footer only for main site */}
      {!isDashboard && <WParkFooter />}
    </div>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
